import { render } from "./LocalitationIcon2.vue?vue&type=template&id=7e597222&scoped=true"
import script from "./LocalitationIcon2.vue?vue&type=script&lang=js"
export * from "./LocalitationIcon2.vue?vue&type=script&lang=js"

import "./LocalitationIcon2.vue?vue&type=style&index=0&id=7e597222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e597222"]])

export default __exports__